import React from 'react'

import { Form, Col } from '_zari/core'

import { TiposTablaComunConstant } from 'constants/index'

import * as TablasComunesService from 'services/tablasComunes.service'

const OrigenFormGroup = ({ value, onChange }) => {
  const [origenes, setOrigenes] = React.useState([])

  React.useEffect(() => {
    TablasComunesService.getAsSelect(TiposTablaComunConstant.ORIGENES).then(({ data }) => {
      setOrigenes(data)
    })
  }, [])

  return (
    <Form.Group>
      <Form.Label text='ORIGEN' htmlFor='select-origen' md={4} />
      <Col md={8}>
        <Form.Select value={value} onChange={onChange} id='select-origen' name='select-origen'>
          <option value=''>Seleccionar</option>
          {origenes.map((val, key) => (
            <option key={key} value={val._id}>
              {val.nombre}
            </option>
          ))}
        </Form.Select>
      </Col>
    </Form.Group>
  )
}

export default React.memo(OrigenFormGroup)
